import returnApi from '@/api/return';

const state = {
    products: null,
    payments: null,
    data: null,
    isLoading: null,
    doingReturn: null,
    receipt: null,
    validationErrors: null
}

export const mutationTypes = {
    getReturnProductsStart: '[return] get return products start',
    getReturnProductsSuccess: '[return] get return products success',
    getReturnProductsFailure: '[return] get return products failure',

    getReturnPaymentsStart: '[return] get return payments start',
    getReturnPaymentsSuccess: '[return] get return payments success',
    getReturnPaymentsFailure: '[return] get return payments failure',

    createReturnStart: '[return] create return start',
    createReturnSuccess: '[return] create return success',
    createReturnFailure: '[return] create return failure',

    returnReceiptStart: '[return] return receipt start',
    returnReceiptSuccess: '[return] return receipt success',
    returnReceiptFailure: '[return] return receipt failure',

    makeReturnStart: '[return] make return start',
    makeReturnSuccess: '[return] make return success',
    makeReturnFailure: '[return] make return failure',

    makeCancelStart: '[return] make cancel start',
    makeCancelSuccess: '[return] make cancel success',
    makeCancelFailure: '[return] make cancel failure',
}

export const returnActionTypes = {
    getReturnProducts: '[return] get return products',
    getReturnPayments: '[return] get return payments',
    createReturn: '[return] create return',
    returnReceipt: '[return] return receipt',
    makeReturn: '[return] make return',
    makeCancel: '[return] make cancel'
}

const mutations = {
    [mutationTypes.getReturnProductsStart](state) {
        state.isLoading = true
        state.products = null
    },
    [mutationTypes.getReturnProductsSuccess](state, payload) {
        state.isLoading = false
        state.products = payload
        state.validationErrors = null
    },
    [mutationTypes.getReturnProductsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getReturnPaymentsStart](state) {
        state.isLoading = true
        state.payments = null
    },
    [mutationTypes.getReturnPaymentsSuccess](state, payload) {
        state.isLoading = false
        state.payments = payload
        state.validationErrors = null
    },
    [mutationTypes.getReturnPaymentsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.createReturnStart](state) {
        state.doingReturn = true
        state.data = null
    },
    [mutationTypes.createReturnSuccess](state, payload) {
        state.doingReturn = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.createReturnFailure](state,payload) {
        state.doingReturn = false
        state.validationErrors = payload
    },

    [mutationTypes.returnReceiptStart](state) {
        state.doingReturn = true
        state.receipt = null
    },
    [mutationTypes.returnReceiptSuccess](state, payload) {
        state.doingReturn = false
        state.receipt = payload
        state.validationErrors = null
    },
    [mutationTypes.returnReceiptFailure](state,payload) {
        state.doingReturn = false
        state.validationErrors = payload
    },

    [mutationTypes.makeReturnStart](state) {
        state.doingReturn = true
        state.data = null
    },
    [mutationTypes.makeReturnSuccess](state, payload) {
        state.doingReturn = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.makeReturnFailure](state,payload) {
        state.doingReturn = false
        state.validationErrors = payload
    },

    [mutationTypes.makeCancelStart](state) {
        state.doingReturn = true
        state.data = null
    },
    [mutationTypes.makeCancelSuccess](state, payload) {
        state.doingReturn = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.makeCancelFailure](state,payload) {
        state.doingReturn = false
        state.validationErrors = payload
    },
}

const actions = {
    [returnActionTypes.getReturnProducts](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getReturnProductsStart)
            returnApi
                .getReturnProducts(data)
                .then(response => {
                    context.commit(mutationTypes.getReturnProductsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getReturnProductsFailure, response)
                })
        })
    },
    [returnActionTypes.getReturnPayments](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getReturnPaymentsStart)
            returnApi
                .getReturnPayments(data)
                .then(response => {
                    context.commit(mutationTypes.getReturnPaymentsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getReturnPaymentsFailure, response)
                })
        })
    },
    [returnActionTypes.createReturn](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createReturnStart)
            returnApi
                .createReturn(data)
                .then(response => {
                    context.commit(mutationTypes.createReturnSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createReturnFailure, response)
                })
        })
    },
    [returnActionTypes.returnReceipt](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.returnReceiptStart)
            returnApi
                .returnReceipt(data)
                .then(response => {
                    context.commit(mutationTypes.returnReceiptSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.returnReceiptFailure, response)
                })
        })
    },
    [returnActionTypes.makeReturn](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.makeReturnStart)
            returnApi
                .makeReturn(data)
                .then(response => {
                    context.commit(mutationTypes.makeReturnSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.makeReturnFailure, response)
                })
        })
    },
    [returnActionTypes.makeCancel](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.makeCancelStart)
            returnApi
                .makeCancel(data)
                .then(response => {
                    context.commit(mutationTypes.makeCancelSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.makeCancelFailure, response)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations
}